import { Injectable } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  isMobile$: Observable<boolean>;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.initResponsive();
  }

  private initResponsive(): void {
    // this.isMobile$ = this.breakpointObserver
    //   .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
    //   .pipe(map(result => !result.matches));
    this.isMobile$ = of(false);
  }
}
